/**
 * Thinking Engine — self-consistency review.
 *
 * The final reasoning step a senior designer performs: check the plan for
 * internal contradictions before committing. Deterministic; returns notes and
 * a verdict that the engine folds into confidence. Reasoning only — no pixels.
 */

import { list } from './reasoning';

const RESTRAINT_CUES = ['restraint', 'refined-type', 'generous-whitespace'];
const LOUD_COLORS = ['neon'];

/**
 * @param {Object} decisions  the produced plan decisions.
 * @returns {{ consistent: boolean, notes: string[] }}
 */
export const runSelfReview = (decisions) => {
  const notes = [];

  const premium = list(decisions.premiumCues && decisions.premiumCues.choice);
  const color = decisions.colorStrategy && decisions.colorStrategy.choice;
  if (premium.some((c) => RESTRAINT_CUES.includes(c)) && LOUD_COLORS.includes(color)) {
    notes.push(`Premium restraint cues conflict with a ${color} palette; reconcile the two.`);
  }

  const hierarchy = decisions.hierarchyStrategy && decisions.hierarchyStrategy.choice;
  if (!Array.isArray(hierarchy) || hierarchy.length === 0) {
    notes.push('Hierarchy is empty; the design has no defined focal order.');
  }

  const priorities = decisions.contentPriorities && decisions.contentPriorities.choice;
  if (!Array.isArray(priorities) || priorities.length === 0) {
    notes.push('Content priorities are empty; nothing to compose.');
  }

  return { consistent: notes.length === 0, notes };
};
